// (function($){
//   $(document).ready(function(){
//   $('.home-core-group-slider').owlCarousel({
//       margin:10,
//       autoplay:true,
//       autoplayTimeout: 1000,
//       slideSpeed : 200,
//       autoplayHoverPause:false,
//       responsive:{
//           0:{
//               items:2,
//               loop:true,
//               center:true,
//               autoplay:true,
//           },
//           700:{
//               items:3,
//               loop:true,
//               center:true,
//               autoplay:true,
//           }
//       }
//   })
//   });
// })(jQuery);

( function($) {
  $( document ).ready( function() {
    $('.custom-mega-menu .subcategories-hover li').hover( function() {
    	$('.custom-mega-menu .subcategories-hover li').removeClass('active');
      	$(this).addClass('active');
      	
      	var hoversub = $(this).data('hover-sub');
      
      	$('.custom-mega-menu .hovered-menu .sub-mega-menu').removeClass('active');
      	$(`.custom-mega-menu .hovered-menu .sub-mega-menu[data-hovered-group="${hoversub}"]`).addClass('active');
    });
  });
})(jQuery);